import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=c7156ffc&scoped=true&lang=pug"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=c7156ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7156ffc",
  null
  
)

export default component.exports